import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-319ee7b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-fail-dialog-content" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "upload-fail-dialog-text" }
const _hoisted_5 = { class: "upload-fail-dialog-footer" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-dianjixiazai" }, null, -1))

import { ref, watch } from 'vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { orderExcelKnowApi, downFailExcelApi } from '@/apis/shopcart'
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: {
  failInfo: {
    type: Object,
    default: () => {
      return {}
    }
  }
},
  emits: ['update:visible', 'success'],
  setup(__props, { emit: emits }) {

const props = __props


const visible = ref(false)
const ok = () => {
  cancel()
}
const cancel = () => {
  orderExcelKnowApi({
    taskId: props.failInfo.taskId
  }).then(() => {
    emits('success')
    emits('update:visible', false)
  })
}
const downLoad = () => {
  downFailExcelApi({
    taskId: props.failInfo.taskId
  }).then((res: any) => {
    console.log('iii', res)
    var blob = new Blob([res])
    if (blob.size > 0) {
      var reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onload = function (e:any) {
        // 转换完成，创建一个a标签用于下载
        var a:any = document.createElement('a')
        a.download = 'fail.xls'
        a.href = e.target.result
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(CommonDialog, {
    visible: visible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    "show-close": false,
    width: 500,
    className: "upload-fail-dialog",
    onOk: ok,
    onCancel: cancel,
    title: _unref(t)('下单失败提示'),
    closeOnClickModal: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "upload-fail-dialog-text",
          innerHTML: _unref(t)('本次导入成功X个订单').replace('X', `<span>${__props.failInfo.successQuantity}</span>`)
        }, null, 8, _hoisted_2),
        _createElementVNode("div", {
          class: "upload-fail-dialog-text",
          innerHTML: _unref(t)('失败X个订单').replace('X', `<span>${__props.failInfo.failQuantity}</span>`)
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('失败订单请重新导入')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", { onClick: downLoad }, [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_unref(t)('失败订单下载')), 1)
          ]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: ok,
            class: "footer-btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('我已知晓')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})